import { render, staticRenderFns } from "./balloon-halloween.vue?vue&type=template&id=fa559f24"
import script from "./balloon-halloween.vue?vue&type=script&lang=js"
export * from "./balloon-halloween.vue?vue&type=script&lang=js"
import style0 from "./balloon-halloween.vue?vue&type=style&index=0&id=fa559f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports